/** TODO - use CartItem from sdk-coin-js */
export enum CartItemSet {
  Ble = 'ble',
  Nfc = 'nfc',
  Nft = 'nft',
  Plus = 'plus',
  Pro = 'pro',
}
